import { deepClone } from '@/services/ObjectFormatter'
export default {
    methods: {
        mixDeepClone: deepClone
    }
}